export class MonthlyPricesRequest {
    constructor(
        public car_ids: string[],
        public percentage_deposit?: number,
        public deposit_amount?: number,
        public term?: number,
        public annual_mileage?: number
    ){}
    }